// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"multiply"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M15.1823 8.81836L12.0003 12.0003M12.0003 12.0003L8.81836 15.1823M12.0003 12.0003L15.1823 15.1823M12.0003 12.0003L8.81836 8.81836","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-multiply')
export default class MultiplyIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'multiply',
    }
  }
}
